/* eslint-disable jira/filename-case */
import { stringify as qsStringify } from 'query-string';
import type {
	SchemaId,
	WorkspaceId,
} from '@jira/servicedesk__insight-common-types-shared-types/src/toCmdbObjectTypeId.tsx';
import type { GlobalConfigObjectRequest } from './TypesGlobalConfigObjectRequest.tsx';
import { getCmdbRestBaseUrl } from './getCmdbRestBaseUrl.tsx';

/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/global
 */
const getCmdbGlobalUrl = (workspaceId: WorkspaceId) => `${getCmdbRestBaseUrl(workspaceId)}/global`;
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/global/config
 */
export const getCmdbGlobalConfigUrl = (workspaceId: WorkspaceId): string =>
	`${getCmdbGlobalUrl(workspaceId)}/config`;
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/global/config/object
 */
export const getCmdbGlobalConfigObjectUrl = (
	workspaceId: WorkspaceId,
	queryParams: GlobalConfigObjectRequest,
): string => `${getCmdbGlobalUrl(workspaceId)}/config/object?${qsStringify(queryParams)}`;
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/global/config/objectschema/${objectSchemaId}
 */
export const getCmdbGlobalConfigObjectSchemaByIdUrl = (
	workspaceId: WorkspaceId,
	objectSchemaId: SchemaId,
): string => `${getCmdbGlobalUrl(workspaceId)}/config/objectschema/${objectSchemaId}`;
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/global/config/objectschema/${objectSchemaId}/property
 */
export const getCmdbGlobalConfigObjectSchemaByIdPropertyUrl = (
	workspaceId: WorkspaceId,
	objectSchemaId: SchemaId,
): string => `${getCmdbGlobalUrl(workspaceId)}/config/objectschema/${objectSchemaId}/property`;
